import React, { useState } from 'react'
import QRImage from '../Images/QR.jpeg'
import { Link } from 'react-router-dom'



function Joinnow() {

    const [Name, setName] = useState('')
    const [PhoneNumber, setPhoneNumber] = useState('')
    const [ListofExchanges, setListofExchanges] = useState('')
    const [Amount, setAmount] = useState('')
    const [UTRID, setUTRID] = useState('')

    // const {setnewUser} = useContext(JoinnowContext);

    // const handelSubmit = (e)=>{
    //   e.preventDefault()
    //   setnewUser({Name,PhoneNumber,ListofExchanges,Amount,UTRID})
    //   setName('')
    //   setPhoneNumber('')
    //   setListofExchanges('')
    //   setAmount('')
    //   setUTRID('')

    //   console.log(Name)

    // }

    return (
        <>
            <div className=' bg-[#000] min-h-screen w-[100%] flex flex-col justify-center items-center pt-6'>
               <h1 className='text-[#ffc107] text-[36px] font-bold text-center mb-5'>Join Us - Complete Your Payment</h1>
               <p className='text-white font-semibold'>Already a User? <span className='text-[#ffc107]' > <Link to='/Deposit'>Click Here to Deposit</Link></span> </p>
                <div className='  w-full max-w-[1200px] flex flex-wrap p-5 justify-between gap-4'>
                    <div className='bg-[#ffffff1a]   md:w-[48%] w-[100%] rounded-lg p-4 flex flex-col justify-center items-center '>
                        <h1 className='text-white text-[32px] font-bold'>Pay via UPI</h1>
                        <img className='w-[150px] rounded-lg mt-2' src={QRImage} alt="" />
                        <div className='bg-[#ffffff33] w-[100%] flex flex-col items-center rounded-lg p-3 mt-4'>
                            <p className='text-white font-semibold my-1'> Bank Name: <span className='font-normal'>Indusland Bank</span></p>
                            <p className='text-white font-semibold my-1'>Account Number: <span className='font-normal'>100117405115</span></p>
                            <p className='text-white font-semibold my-1'> IFSC Code: <span className='font-normal'>INDB0000008</span></p>
                            <p className='text-white font-semibold my-1'>Account Holder Name: <span className='font-normal'>JS Enterprises
                            </span></p>

                            <button className='w-[100%] bg-[#ffc107] text-[#000000] py-[4px] mt-2 rounded-lg hover:bg-[#e57300]'> Check Payment Status</button>

                        </div>
                    </div>
                    <div className='bg-[#ffffff1a] md:w-[48%] w-[100%]  rounded-lg p-4 flex flex-col justify-center  '>
                        <h1 className='text-white text-[32px] font-bold text-center'>Payment Details</h1>
                        <div className='flex flex-col gap-2'>
                            <label className='text-[#ffc107] font-semibold' >Name</label>
                            <input type="text" placeholder='Enter your Name' className='py-2 px-2 rounded-lg outline-[#0075fa]'
                            value={Name}
                            onChange={(e)=>{
                                setName(e.target.value)
                            }}
                            />
                            <label className='text-[#ffc107] font-semibold' >Phone Number</label>
                            <input type="text" placeholder='Enter Phone Number' className='py-2 px-2 rounded-lg outline-[#0075fa]' 
                             value={PhoneNumber}
                            onChange={(e)=>{
                                setPhoneNumber(e.target.value)
                            }}
                            />
                            <label className='text-[#ffc107] font-semibold' >List of Exchanges</label>
                            <select className='py-2 px-2 rounded-lg outline-[#0075fa] w-full'
                             value={ListofExchanges}
                            onChange={(e)=>{
                                setListofExchanges(e.target.value)
                            }}
                            >
                                <option value="">Select a Site</option>
                                <option value="silver">Silver Exch</option>
                                <option value="saffron">Saffron Exch</option>
                                <option value="all">All Panel</option>
                            </select>
                            <label className='text-[#ffc107] font-semibold' >Amount</label>
                            <input type="text" placeholder='Amount' className='py-2 px-2 rounded-lg outline-[#0075fa]' 
                             value={Amount}
                            onChange={(e)=>{
                                setAmount(e.target.value)
                            }}
                            />
                            <label className='text-[#ffc107] font-semibold' >UTR ID</label>
                            <input type="text" placeholder='Enter UTR ID' className='py-2 px-2 rounded-lg outline-[#0075fa]'
                             value={UTRID}
                            onChange={(e)=>{
                                setUTRID(e.target.value)
                            }} />
                            <button  className='w-[100%] bg-[#ffc107] text-[#000000] py-[6px] mt-2 rounded-lg hover:bg-[#e57300]'> Submit Payment</button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Joinnow